import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  mainPaper: {
    display: 'flex',
    flexDirection: 'column',
    // justifyContent: 'space-between',
    flex: 1,
    padding: theme.spacing(1),
    overflowY: 'scroll',
    ...theme.scrollbarStyles,
    border: 'none'
  },
  statusDisconnected: {
    color: theme.palette.red_100.main
  },
  statusConnected: {
    color: theme.palette.green_200.main
  },
  statusTimeout: {
    color: theme.palette.yellow_400.main
  },
  statusQrcode: {
    color: theme.palette.yellow_400.main
  },
  statusDefault: {
    color: theme.palette.green_200.main
  },
  statusWaiting: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  statusButton: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  statusButtonDisconnect: {
    color: theme.palette.red_100.main
  },
  buttonNewQrCode: {
    '& .MuiButton-label': {
      display: 'flex',
      gap: 8
    },
    backgroundColor: theme.palette.blue_300.main,
    color: theme.palette.white_100.main,
    borderRadius: 8,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: theme.palette.green_200.main,
      boxShadow: 'none'
    }
  },
  buttonActionEdit: {
    padding: '6px',
    borderRadius: 8,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_300.main,
    '&:hover': {
      backgroundColor: theme.palette.blue_300.main,
      color: theme.palette.white_100.main
    }
  },
  buttonActionDelete: {
    padding: '6px',
    borderRadius: 8,
    color: theme.palette.red_100.main,
    '&:hover': {
      backgroundColor: theme.palette.red_100.main,
      color: theme.palette.white_100.main
    }
  },
  buttonActionPrivacy: {
    padding: '6px',
    borderRadius: 8,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_300.main,
    '&:hover': {
      backgroundColor: theme.palette.blue_300.main,
      color: theme.palette.white_100.main
    }
  },
  customTableCell: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: theme.typography.pxToRem(14),
    border: '1px solid #dadde9',
    maxWidth: 450
  },
  tooltipPopper: {
    textAlign: 'center'
  },
  buttonProgress: {
    color: theme.palette.green_whatsApp.main
  },

  buttonNewConection: {
    backgroundColor: theme.palette.green_200.main,
    color: '#fff',
    borderRadius: 8,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: theme.palette.blue_300.main,
      boxShadow: 'none'
    }
  },
  containerProps: {
    elevation: 0
  },
  tab: {
    borderBottom:
      theme.palette.type === 'dark'
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`,
    '& .MuiTab-root': {
      minHeight: '28px',
      minWidth: '110px',
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_600.main
          : theme.palette.gray_100.main
    },
    '& .MuiTabs-indicator': {
      display: 'none'
    },
    '& .MuiTabScrollButton-root': {
      width: '25px'
    }
  },
  tabHeader: {
    // backgroundColor: theme.palette.blue_300.main,
    borderRadius: '8px 8px 0 0',
    margin: '12px 0 0 0',
    padding: '2px 4px',
    position: 'relative',
    zIndex: 1,
    // boxShadow: '0 2px 5px rgba(0,0,0,0.1)',

    '&.Mui-selected': {
      backgroundColor: theme.palette.blue_300.main,
      color: theme.palette.white_100.main,
      zIndex: 2,
      '& span': {
        color: theme.palette.white_100.main
      }
    }
  },
  container: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  },
  contentTable: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'space-between'
  },
  warningZone: {
    display: 'flex',
    flexDirection: 'column',
    padding: '8px',
    backgroundColor: theme.palette.red_200.main
  },

  warningZoneTitle: {
    fontWeight: 600,
    color: theme.palette.red_100.main
  },
  warningZoneInfo: {
    color: theme.palette.red_100.main,
    fontSize: 14
  },
  cardContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    // '& > *': {
    //   width: '420px'
    // }
  }
}))
